import React, { useContext, useEffect } from "react";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import ConfigurationContext from "../../contexts/ConfigurationContext";
import apiRequest from "../../api/apiRequest";
import urls from "../../api/urls";

export const Layout = props => {
  const { children } = props || {};
  const { configurations } = useContext(ConfigurationContext);

  const [isSidebarOpen, setSidebarOpen] = React.useState(false);

  const handleSidebarToggle = () => setSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const injectAllPageScripts = async () => {
      try {
        const scripts = await apiRequest({ method: "get", url: `${urls.scripts}?page=all` });
        if (!scripts || !scripts.length) return;
        scripts.forEach(script => {
          if (script.html) {
            const container = document.createElement("div");
            container.innerHTML = script.html;
            Array.from(container.querySelectorAll("script")).forEach(s => {
              const tag = document.createElement("script");
              if (s.src) tag.src = s.src;
              else tag.innerHTML = s.innerHTML;
              tag.async = true;
              document.head.appendChild(tag);
            });
            Array.from(container.childNodes).forEach(node => {
              if (node.nodeName !== "SCRIPT") document.body.appendChild(node.cloneNode(true));
            });
          }
          if (script.script) {
            const tag = document.createElement("script");
            tag.src = script.script;
            tag.async = true;
            document.head.appendChild(tag);
          }
        });
      } catch (e) {}
    };
    injectAllPageScripts();
  }, []);

  return (
    <React.Fragment>
      {configurations.custom_header_enabled && configurations.custom_header_html
        ? <div dangerouslySetInnerHTML={{ __html: configurations.custom_header_html }} />
        : configurations.show_header && <Header onToggle={handleSidebarToggle} />
      }
      <Navbar />
      <main>{children}</main>
      {configurations.custom_footer_enabled && configurations.custom_footer_html
        ? <div dangerouslySetInnerHTML={{ __html: configurations.custom_footer_html }} />
        : configurations.show_footer && <Footer />
      }
      <Sidebar isOpen={isSidebarOpen} onClose={handleSidebarToggle} />
    </React.Fragment>
  );
};

export default Layout;
